// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2Igs9","container":"styles_container__3Nri_","content":"styles_content__2QD56"};